import React from 'react';
 
const RefreshPage = () => {
  const handleRefresh = () => {
    window.location.reload(); // Refreshes the current tab
  };
 
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="bg-white p-12 rounded-xl shadow-md max-w-lg text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          Oops, Page Timeout!
        </h1>
        <p className="text-lg text-gray-500 mb-8">
          It looks like you've been inactive for a while. Please refresh the page to continue.
        </p>
        <button
          onClick={handleRefresh}
          className="px-6 py-3 bg-teal-500 text-white font-medium rounded-full shadow-lg hover:bg-teal-600 transition-colors duration-300 focus:outline-none focus:ring-4 focus:ring-teal-300"
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
};
 
export default RefreshPage;